/*
 * CODE GENERATED AUTOMATICALLY WITH GraphQL Codegen
 * THIS FILE SHOULD NOT BE EDITED MANUALLY.
 */
import {
  BaseQueryModel,
  IQueryModelOpts,
  useQuery,
  useGqlClient,
} from '@r-client/shared/data/client';
import {
  IHasWalletQuery,
  IHasWalletQueryVariables,
  HasWalletDocument,
} from './types';

export type IHasWalletQueryOpts = IQueryModelOpts<IHasWalletQueryVariables>;

export class HasWalletQuery extends BaseQueryModel<
  IHasWalletQuery,
  IHasWalletQueryVariables
> {
  // This is fine. Here we explicitly change interface for query
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(opts: IHasWalletQueryOpts) {
    super(opts);
  }

  get query() {
    return HasWalletDocument;
  }
}
export function useHasWalletQuery(opts?: Omit<IHasWalletQueryOpts, 'client'>) {
  const client = useGqlClient();
  return useQuery(
    () => new HasWalletQuery({ ...opts, client }),
    opts?.variables
  );
}
